import { log } from './logger'
import { isAndroidNativeApp, isIosNativeApp } from '../nativeWebInteraction/nativeWebInteraction'

export const NEWEST_NATIVE_IOS_APP_VERSION = 212
export const NEWEST_NATIVE_ANDROID_APP_VERSION = 212

export const MIN_NATIVE_APP_VERSION_FOR_PLAID_HOSTED_LINK_TO_WORK = 210

export const getNativeAppVersion = (): number | null => {
    log.info('getNativeAppVersion => window.nativeAppVersion: %{windowNativeAppVersion}', { windowNativeAppVersion: window.nativeAppVersion })

    if (!window.nativeAppVersion) {
        log.error('getNativeAppVersion => window.nativeAppVersion is null')
        return null
    }

    const nativeAppVersion = parseInt(window.nativeAppVersion, 10)
    log.info('getNativeAppVersion => nativeAppVersion: %{nativeAppVersion}', { nativeAppVersion })

    if (isNaN(nativeAppVersion)) {
        log.error('getNativeAppVersion => nativeAppVersion is NaN')
        return null
    }

    return nativeAppVersion
}

export const isNativeAppVersionUpdateAvailable = (): boolean => {
    let newestNativeAppVersion = null
    if (isAndroidNativeApp()) {
        newestNativeAppVersion = NEWEST_NATIVE_ANDROID_APP_VERSION
    } else if (isIosNativeApp()) {
        newestNativeAppVersion = NEWEST_NATIVE_IOS_APP_VERSION
    } else {
        log.warn('isNativeAppVersionUpdateAvailable => nativeAppVersion is not Android or iOS - likely running in web')
        return false
    }

    const nativeAppVersion = getNativeAppVersion()
    if (nativeAppVersion === null) {
        log.error('isNativeAppVersionUpdateAvailable => nativeAppVersion is null')
        return false
    } else if (nativeAppVersion > newestNativeAppVersion) {
        log.error('isNativeAppVersionUpdateAvailable => nativeAppVersion is greater than newestNativeAppVersion: %{nativeAppVersion} > %{newestNativeAppVersion} this should not be possible', {
            nativeAppVersion,
            newestNativeAppVersion,
        })
        return false
    } else if (nativeAppVersion === newestNativeAppVersion) {
        log.info('isNativeAppVersionUpdateAvailable => nativeAppVersion is the same as newestNativeAppVersion: %{nativeAppVersion} === %{newestNativeAppVersion}', {
            nativeAppVersion,
            newestNativeAppVersion,
        })
        return false
    }
    log.info('isNativeAppVersionUpdateAvailable => nativeAppVersion is less than newestNativeAppVersion: %{nativeAppVersion} < %{newestNativeAppVersion}', { nativeAppVersion, newestNativeAppVersion })
    return true
}
